import { Backdrop, CircularProgress } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react'
import { useSearchParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDepartmentInfo, getDoctorPatients } from '../api/routes';
import Footer from '../components/Footer'
import Nav from '../components/Nav'
import PatientTable from './../components/PatientTable';

export default function DoctorPatients() {
    const [searchParams] = useSearchParams();
    const [departmentInfo, setDepartmentInfo] = useState();
    const [telDct, setTelDct] = useState("");
    const [loading, setLoading] = useState(false);
    const [doctorPatients, setDoctorPatients] = useState([])
    const submitRef = useRef(null)

    useEffect(() => {
  /*       getDepartmentInfo((isOk, data) => {
            if (!isOk) return alert(data.message);

            else return setDepartmentInfo(data)
        }) */
    }, [])

    useEffect(() => {
        if (searchParams.get("q")) {
            setLoading(true)
            getDoctorPatients(searchParams.get("q"), (isOk, data) => {
                if (!isOk) {
                    setLoading(false)
                    return alert(data.message);
                }
                else {
                    if (data.length === 0) {
                        setLoading(false)
                        return toast.error('بیماری یافت نشد!')
                    }
                    else {
                        setLoading(false)
                        return setDoctorPatients(data)
                    }
                }
            })
        }
    }, [searchParams.get("q")])

    const numberRegex = /^[0-9]*$/g;

    const codeReceptionChange = (event) => {
        if (event.target.value === '')
            return setTelDct(event.target.value)
        else if (event.target.value.match(numberRegex)) {
            return setTelDct(event.target.value)
        } else return alert('عدد وارد کنید!')
    }
    const onClickEnter = (event) => {
        if (event.key === 'Enter' && telDct !== '') {
            event.preventDefault();
            event.stopPropagation();
            submitRef.current.click()
        }
    }
    return (
        <>
            <div className='container'>
                <Nav logo={departmentInfo && departmentInfo[0].logo} />
                <div className="flex pt-28 pb-16 sm:pt-40 sm:pb-[9.5rem] flex-col items-center">
                    {doctorPatients.length === 0 ? <section className="h-fit bg-white lg:w-[40%] w-[95%] box-shadow rounded-lg py-6 sm:py-12 px-4 md:p-12">
                        <p className='font-bold mb-4 text-base sm:text-lg'>براي مشاهده لیست بیماران خود به نكات ذيل توجه نماييد:</p>
                        <p className='text-sm sm:text-base'>• در كادر پايين، كلمه عبور اختصاص داده شده را وارد نموده و كليد ادامه را بزنيد.</p>
                        <p className='text-sm sm:text-base my-4'>• پس از ورود، مي توانيد ليست بيماراني كه به این کلینیک ارجاع داده ايد را مشاهده نماييد. بيماراني كه گزارش و تصاوير آنها آماده باشد داراي آيكون مربوطه خواهند بود.</p>
                        <p className='text-sm sm:text-base'>• درصورت داشتن سوال مي توانيد با شماره تلفن 38400775 051 تماس بگيريد.</p>
                        <div className='flex items-center mt-8'>
                            <input onKeyDown={onClickEnter} type='tel' value={telDct} onChange={codeReceptionChange} placeholder="کلمه عبور" className='flex-1 text-center border rounded-lg h-[44px] px-4' />
                            <Link ref={submitRef} to={telDct === '' ? '/doctor-patients' : `/doctor-patients?q=${telDct}`}>
                                <button type="button" className='focus:outline-none text-white bg-[#15bd9b] font-medium rounded-lg px-8 sm:px-12 py-2.5 mr-4'>ادامه</button>
                            </Link>
                        </div>
                    </section>
                        : <PatientTable data={doctorPatients} />}
                </div>
            </div>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Footer data={departmentInfo && departmentInfo[0]} />
        </>
    )
}
